import { Component, Injector, OnInit } from "@angular/core";
import { GenericComponent } from "../../components/generic.component";
import { MatDialogRef } from "@angular/material/dialog";
import { MessageBeforeManuallyAddPartActionsEnum } from "../../enums/message-before-manually-add-part-actions.enum";

@Component({
    selector: "app-smartfleet-message-before-manually-add-part-warning-user-modal",
    templateUrl: "./message-before-manually-add-part-warning-user-modal.component.html",
    styleUrls: [
        "./message-before-manually-add-part-warning-user-modal.component.scss"
    ],
    standalone: false
})
export class MessageBeforeManuallyAddPartWarningUserModalComponent extends GenericComponent {
  constructor(
    injector: Injector,
    private matDialogRef: MatDialogRef<MessageBeforeManuallyAddPartWarningUserModalComponent>
  ) {
    super(injector);
  }

  callUseExistingPart() {
    this.closeDialog(MessageBeforeManuallyAddPartActionsEnum.USE_EXISTING_PART);
  }

  callCreatePart() {
    this.closeDialog(MessageBeforeManuallyAddPartActionsEnum.CREATE_PART);
  }

  callCloseDialog() {
    this.closeDialog(null);
  }

  closeDialog(action: MessageBeforeManuallyAddPartActionsEnum) {
    this.matDialogRef.close(action);
  }
}
